module.exports = __webpack_public_path__ + "img/vision_02.067fea25.jpg";